import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneInput } from '@yy/one-ui'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../rules'

interface IProps {
  required?: boolean
  defaultValue?: string
  countryCode?: string
  channelCode?: string
}

const ConsigneeIdNumField: FC<IProps> = (props) => {
  const { t } = useTranslation()
  const { required, defaultValue = '', countryCode, channelCode, ...args } = props

  return (
    <FormItem
      required={required}
      initialValue={defaultValue}
      rules={RULES.provider_consignee_id_num({ isRequired: required, countryCode, channelCode })}
      name="provider_consignee_id_num"
      label={t('logistics.create.cardNumber')}
    >
      <OneInput placeholder={t('common.input.placeholder')} {...args} />
    </FormItem>
  )
}

export default ConsigneeIdNumField
